import React,{Component} from 'react';
import firebase from '../../config'
import {Form,Input} from 'antd'
import {Button,Box} from '@material-ui/core'
import PhoneInput from 'react-phone-input-2'



export default class Report extends Component{
    constructor(){
        super()
        this.state={
            files:null,
            phone:null,
            name:null,
        }
    }
    handleChange=(files)=>{
        this.setState({files:files});
    }
    componentDidMount(){
        let storageRef = firebase.storage().ref("reports/Gaurav_resume (1).pdf");

        storageRef.getDownloadURL().then((url)=>{
            console.log(url)
        })
    }
    handleSave = (id) =>{
        return new Promise((resolve) =>{
            let file = this.state.files[0];
            console.log(file.name)
            let storageRef = firebase.storage().ref("reports/"+id);
            let uploadTask = storageRef.put(file).then(()=>{
                resolve();
            })

        })

    }
    submit =async  (values) =>{
        console.log(values,this.state)
        let id = this.id();
        await this.handleSave(id);
        const url =  await firebase.storage().ref("reports/"+id).getDownloadURL();
        var obj = {
            url : url,
            name : values.name,
        }
        firebase.firestore().collection("users").doc(`+${values.phone}`).collection("reports").add(obj).then(()=>{
            console.log("upload succeful")
            alert("Upload Succesful");
            this.setState({
                phone:null,
                name:null
            })
        })


    }
    id = function () {
        // Math.random should be unique because of its seeding algorithm.
        // Convert it to base 36 (numbers + letters), and grab the first 9 characters
        // after the decimal.
        return Math.random().toString(36).substr(2, 9);
      };
    form = () =>{
        return <Form onFinish={this.submit}>
            <Form.Item name="phone" label="Phone no">
                        <PhoneInput
                            country={'in'}
                            value={this.state.phone}
                            onChange={phone => this.setState({ phone })}
                            inputStyle={{blockSize:"10px 10px"}}
                        />
            </Form.Item>
            <Form.Item name="name" lable="Report Name">
                <Input  value={this.state.name} onChange={name => this.setState({name:name})} placeholder="Enter Report Name"/>
            </Form.Item>
            <Form.Item>
                <Input type="file"  onChange={(e) => this.handleChange(e.target.files)}/>
            </Form.Item>
            <Form.Item>
                <Button color="secondary" id="#submit" type="primary" htmlType="submit">Upload</Button>
            </Form.Item>
        </Form>
    }
    render(){
        return(
            <div>

                <Box>
                    <this.form />
                </Box>

            </div>

        )
    }
}